export function authHeader() {
  // return authorization header with jwt token
  let token = localStorage.getItem("authToken");
  if (token) {
    return { Authorization: "Bearer " + token };
  } else {
    return {};
  }
}
